import Highway from '@dogstudio/highway';

export default class DefaultPageRenderer extends Highway.Renderer {

  onEnter() {

    console.log('new page');
    this.DOM = { view: this.wrap.lastElementChild };

  }

}
